export default {
    start: {},
    ping: {},
    isStarting: false,
}
